/**
 * Copyright (c) 2010-2025 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, OnInit } from '@angular/core';
import {
    MatDialogRef,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
} from '@angular/material/dialog';
import { DevicePermissionState, requestPermission } from 'fulltilt';
import { LoggerService } from '../../shared/services/logger.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'cs-permission-request',
    templateUrl: './permission-request.component.html',
    styleUrls: ['./permission-request.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose],
})
export class PermissionRequestComponent implements OnInit {
    constructor(private logger: LoggerService, private dialogRef: MatDialogRef<PermissionRequestComponent>) {}

    ngOnInit(): void {}

    async requestPermission() {
        const permission: DevicePermissionState = await requestPermission('orientation');
        this.dialogRef.close(permission.orientation === 'granted');
    }
}
